module.exports = __webpack_public_path__ + "img/receipt_black_24dp.7c0967a0.svg";